export const ARROW_ICONS = {
  arrowPopupCpk:
    'https://cdn.naviparking.com/digital_parking/assets/arrow-popup-cpk.svg',
  arrow: 'https://cdn.naviparking.com/digital_parking/assets/arrow.svg',
  blueChevron:
    'https://cdn.naviparking.com/digital_parking/assets/blueChevron.svg'
} as const

export type ArrowIconKey = keyof typeof ARROW_ICONS

export const getArrowIcon = (iconKey: ArrowIconKey): string => {
  return ARROW_ICONS[iconKey]
}
